import { connect } from 'react-redux';

import decorate from '../../../utils/decorate';

import ReportsFilter from './ReportsFilter.jsx';

import * as query from '../../../modules/reports/actions/query';
import * as run from '../../../modules/reports/actions/run';

const STATE_KEY = 'reports';

function mapStateToProps(state) {
    return {
        state: state.reports.getIn([ 'runReport', 'state' ]),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetReportsRequest: (type, accountId) => dispatch(query.request(STATE_KEY, type, accountId)),
        onRunReportRequest: (type, accountId, params) => dispatch(run.request(type, accountId, params)),
        onClear: () => {
            dispatch(query.clear(STATE_KEY));
            dispatch(run.clear());
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    ReportsFilter
);
